/* eslint no-shadow: ["error", { "allow": ["state", "getters"] }] */
/* eslint object-curly-newline: ["error", { "multiline": true }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import axios from 'axios';

// initial state
const state = {
  contacts: null,
  loaders: {
    contacts: false,
  },
  initializers: {
    contacts: false,
  },
};

// getters
const getters = {
  contacts: (state) => state.contacts,
  loaders: (state) => state.loaders,
  initializers: (state) => state.initializers,
};

// actions
const actions = {
  setProperty({ commit }, payload) {
    commit('SET_PROPERTY', payload);
  },

  getContacts({ commit }) {
    commit('TOGGLE_LOADING', { key: 'contacts', value: true });
    return axios.get(`${CONFIG.get('BASE_URL')}/api/contacts/getContacts/`)
      .then(({ data }) => {
        // Don't do this if not using large top banner
        commit('SET_PROPERTY', { key: 'contacts', value: data });
      })
      .catch(() => {})
      .finally(() => {
        commit('TOGGLE_LOADING', { key: 'contacts', value: false });
      });
  },

};

// mutations
const mutations = {
  SET_PROPERTY(state, payload) {
    state[payload.key] = payload.value;
  },
  TOGGLE_LOADING(state, payload) {
    state.loaders[payload.key] = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
